import React from 'react'

export default function FaceFeature({ scale, verticalOffset }) {
  const transformOrigin = '21.5 7.7'
  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M18.7397 5.58987C18.7397 5.58987 21.4698 4.01987 24.3798 5.58987"
        stroke="#644534"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9.09984 0.509905C13.2298 0.429905 17.8899 1.1599 18.4299 4.2199C18.9099 6.9899 16.8899 14.6899 9.54985 15.0399C2.20985 15.3899 0.15985 7.5699 1.10985 4.0399C1.90985 1.0799 4.83984 0.599905 9.09984 0.509905Z"
        stroke="#644534"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M33.93 0.509905C29.8 0.429905 25.14 1.1599 24.6 4.2199C24.12 6.9899 26.14 14.6899 33.48 15.0399C40.82 15.3899 42.87 7.5699 41.92 4.0399C41.12 1.0799 38.19 0.599905 33.93 0.509905Z"
        stroke="#644534"
        strokeMiterlimit="10"
        fill="none"
      />
    </g>
  )
}
